import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/UserCase';
import { EventRepository } from '../../repositories/event/EventRepository';
import {
  DetalleZonaRequestDTO,
  DetalleZonaDTO
} from 'src/app/data/dto/EventDTO';

@Injectable({
    providedIn: 'root'
})

export class ZonaUseCase implements UseCase<DetalleZonaRequestDTO, DetalleZonaDTO>{
    constructor(
        private eventRepository: EventRepository,
    ) { }
    execute(id: DetalleZonaRequestDTO): Observable< DetalleZonaDTO > {
        return this.eventRepository.zonasById(id);
    }
}
